module.exports = __webpack_public_path__ + "img/artnhealing_option_01.cf0bbfbe.jpg";